<form [formGroup]="poForm" novalidate (ngSubmit)="save()">
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title>
        <h2>Funding Categories</h2>
      </mat-card-title>
      <mat-card-subtitle>Display names appear on the student results page as soon as you save. Caps and floors go live when calculation rules are published.</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <table class="table">
        <tr>
          <th scope="col">Funding Category</th>
          <th scope="col" id="caps-name-header">Display name</th>
          <th scope="col" id="caps-cap-header">Cap</th>
          <th scope="col" id="caps-floor-header">Floor</th>
        </tr>

        @for (category of categories; track category.formKey) {
          <tr [formGroupName]="category.formKey">
            <th scope="row" [id]="getRowHeaderId(category.formKey)">{{ category.label }}</th>
            <td>
              @if (category.nameDefault) {
                <mat-form-field class="name-field" subscriptSizing="dynamic">
                  <input matInput [placeholder]="category.nameDefault" type="text" formControlName="name" [attr.aria-labelledby]="getFieldLabelIds('name', category.formKey)" />
                </mat-form-field>
              }
            </td>
            <td>
              @if (category.hasCap) {
                <mat-form-field class="amount-field" subscriptSizing="dynamic">
                  <input matInput placeholder="Edit" type="number" formControlName="cap" [attr.aria-labelledby]="getFieldLabelIds('cap', category.formKey)" />
                </mat-form-field>
              }
            </td>
            <td>
              @if (category.hasCap) {
                <mat-form-field class="amount-field" subscriptSizing="dynamic">
                  <input matInput placeholder="Edit" type="number" formControlName="floor" [attr.aria-labelledby]="getFieldLabelIds('floor', category.formKey)" />
                </mat-form-field>
              }
            </td>
          </tr>
        }
      </table>

      @if (state == "error") {
        <div class="alert alert-warning" role="alert">An error has occurred attempting to save changes</div>
      }
      <div class="category-actions">
        <button mat-raised-button color="primary" type="submit" [disabled]="!poForm.valid || (state != 'modified' && state != 'error')">
          {{ state == "modified" || state == "error" ? "Save Changes" : "No unsaved changes" }}
        </button>
        <button mat-stroked-button type="button" (click)="cancel()" [disabled]="state != 'modified' && state != 'error'">Cancel</button>
      </div>
    </mat-card-content>
  </mat-card>
</form>
